/**
 * включение скролла на странице
 */
export const enableScroll = () => {
  window.onscroll = () => true;
};
